import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getProductPriceTitle, resolveProductImage, routeToProduct } from '@/helpers'
import { debounce, map } from 'lodash'

export default {
  name: 'basket-item',
  props: {
    basketHasPromotion: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedCount: 1,
    }
  },
  computed: {
    ...mapGetters({
      basket: 'basket/basket',
      user: 'profile/user',
      promotionResponse: 'basket/promotionResponse',
      giftPayloadItems: 'gifts/giftPayloadItems',
    }),
    hasPromotion() {
      return false
      return this.product.select_type.hasActivePromotion || this.product.select_type.hasIndividualDiscount
    },
    checkBasketContainsPromotion() {
      return false
      return this.basket.findIndex((product) => product.select_type.hasActivePromotion || product.select_type.hasIndividualDiscount) !== -1
    },
    currentProductPrice() {
      return this.product.select_type.hasActivePromotion || this.product.select_type.hasIndividualDiscount
        ? this.product.select_type.oldPrice
        : this.product.select_type.price
    },
  },
  async created() {
    await this.fetchPromotionData()
  },
  methods: {
    getProductPriceTitle,
    routeToProduct,
    resolveProductImage,
    ...mapMutations({
      increment: 'basket/INCREMENT_BASKET_LIST_COUNT',
      decrement: 'basket/DECREMENT_BASKET_LIST_COUNT',
      setCount: 'basket/SET_BASKET_LIST_COUNT',
      remove: 'basket/REMOVE_ITEM_FROM_BASKET',
    }),

    ...mapActions({
      fetchPromotion: 'basket/FETCH_PROMOTION',
      removeSelectedGift: 'gifts/REMOVE_SELECTED_GIFT',
    }),

    fetchPromotionData: debounce(async function () {
      const nonGiftItems = this.basket
        .filter((p) => !p.isFree)
        .map((product) => ({
          id: product.id,
          product_price_id: product.select_type.id,
          count: product.select_count,
          is_present: product.isPresent || false,
          is_added_from_sale: product.isAddedFromSale || false,
        }))
      const giftItemsFromBasket = this.basket
        .filter((p) => p.isFree)
        .map((product) => ({
          product_price_id: product.select_type.id,
          count: product.select_count,
          is_free: true,
          sale_id: product.saleId ?? null,
        }))
      const giftItems = giftItemsFromBasket.length
        ? giftItemsFromBasket
        : this.giftPayloadItems || []
      const payload = {
        products: [...nonGiftItems, ...giftItems],
      }

      await this.fetchPromotion(payload)
    }, 500),
    isSample(product) {
      return product.type === 'sampler' && product.allProductSum / product.select_count === 0.01
    },
    allowedProductManipulations(product) {
      return !product.isAddedFromSale && !this.isSample(product)
    },

    findCurrentProductPromotionBanner(id) {
      if (!this.promotionResponse || !this.promotionResponse.closestSales) return null

      const promotion = this.promotionResponse.closestSales.find((promo) => promo.productPricesToApply.includes(id))

      return promotion || null
    },

    async changeCount(type, count = 1) {
      if (type === 'increment') {
        this.increment(this.product)
      } else if (type === 'decrement') {
        this.decrement(this.product)
      } else {
        if (count) {
          this.setCount({
            product: this.product,
            select_count: parseInt(count),
          })
        }
      }
      await this.fetchPromotionData()
    },

    async handleRemove(item) {
      if (item.isFree) {
        await this.removeSelectedGift({
          productPriceId: item.select_type?.id,
          saleId: item.saleId ?? null,
        })
      }
      this.remove(item)
      await this.fetchPromotionData()
    },
  },
}
